module.exports = __webpack_public_path__ + "img/banner-5.e30a5477.jpg";